<div class="recommendations">
  <mat-label>Recommendations</mat-label>
  <mat-chip-set>
    @for (r of recommendations(); track r; let idx = $index) {
    <mat-chip [removable]="removable" (removed)="onDelete(idx)" color="primary">
      From: {{ r.from }} -- To: {{ r.to }}
      @if (removable) {
      <mat-icon matChipRemove class="cancel-button" matSuffix>cancel</mat-icon>
      }
    </mat-chip>
    }
  </mat-chip-set>
  <!-- Add New Series and Reading Order -->
  <kbm-recommendation-row (addNewRecommendationEvent)="addRecommendation($event)"></kbm-recommendation-row>
</div>